import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { KeeniconComponent } from '../keenicon/keenicon.component';

@Component({
  selector: 'ui-symbol',
  imports: [KeeniconComponent, KeeniconComponent],
  templateUrl: './symbol.component.html',
  styleUrl: './symbol.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SymbolComponent {
  severity = input<string>('info');
  symbolClass = input<string>('');
  iconName = input<string>('');
}
